/* eslint-disable no-unused-vars */
import QRCode from "qrcode.react";
import { React, useState, useEffect } from "react";
import { HiClipboardCopy } from "react-icons/hi";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { useResizeDetector } from "react-resize-detector";
import ARControllerUI from "../components/ARControllerUI";
import "./QRPage.css";

const QRPage = () => {
  const { width, height, ref } = useResizeDetector();
  const [smallwin, setSmallwin] = useState(false);
  const url = new URL(window.location);
  url.searchParams.set("ar", 1);
  window.history.pushState({}, "", url);
  const [copied, setCopied] = useState(false);
  const value = `${url.href}`;
  const handleCopy = () => {
    setCopied(true);
    console.log("HELLO");
    // setTimeout(() => {
    //   setCopied(false);
    // }, 2000);
  };
  useEffect(() => {
    if (height < 500) {
      setSmallwin(true);
    } else {
      setSmallwin(false);
    }
  }, [height]);
  return (
    <div className="QRScene" ref={ref}>
      <ARControllerUI />
      {!smallwin ? (
        <p
          style={{
            color: "gray",
            marginTop: "6vh",
            fontSize: "2vh",
            position: "absolute",
            top: "90px",
          }}
        >
          -- This device does not support AR --
        </p>
      ) : (
        <p
          style={{
            color: "gray",
            fontSize: "13px",
            position: "absolute",
            top: "100px",
            marginTop: "4vh",
          }}
        >
          Supported on smartphone, scan QR Code or copy link to begin
        </p>
      )}
      <div className={!smallwin ? "QRbody" : "QRbody-small"}>
        <QRCode
          className={!smallwin ? "QRCard" : "QRCard-small"}
          value={url.href}
          // size={250}
          fgColor="lightgray"
          bgColor="#222"
          includeMargin
        />

        {!smallwin && (
          <h3 className="QRInfo_Text">
            To begin experience on your smartphone, <br />
            Scan the QR Code or copy the link below.{" "}
          </h3>
        )}

        <CopyToClipboard onCopy={handleCopy} text={value}>
          <div className={!smallwin ? "QRLink" : "QRLink-small"}>
            <div
              className={!smallwin ? "QRLinkCopyIcon" : "QRLinkCopyIcon-small"}
            >
              <HiClipboardCopy color="#dde1e7" size={!smallwin ? "30" : "20"} />
            </div>

            {copied ? (
              <p
                className={!smallwin ? "QRLinkText" : "QRLinkText-small"}
                style={{ color: "green" }}
              >
                Copied
              </p>
            ) : (
              <p className={!smallwin ? "QRLinkText" : "QRLinkText-small"}>
                Copy Link
              </p>
            )}
          </div>
        </CopyToClipboard>
      </div>
    </div>
  );
};

export default QRPage;
